// Native product submission and Shopify's recipient component own checkout.
// This only synchronises the decorative amount and shareable variant URL.
document.addEventListener('change', event => {
  const radio = event.target;
  if (!(radio instanceof HTMLInputElement) || !radio.matches('[data-gift-amount]')) return;
  const root = radio.closest('.gift-studio');
  const value = root?.querySelector('[data-gift-value]');
  if (value) value.textContent = radio.dataset.giftAmount;
  if (document.querySelector('#MainContent[data-template^="product"]')) {
    const url = new URL(location.href);
    url.searchParams.set('variant', radio.value);
    history.replaceState({}, '', url);
  }
});
